"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useStore, useStoreProps } from "./CTKPPFRS.js";
import { useUpdateEffect } from "./HNHAUIIY.js";

// src/disclosure/disclosure-store.ts
import * as Core from "@ariakit/core/disclosure/disclosure-store";
function useDisclosureStoreProps(store, update, props) {
  useUpdateEffect(update, [props.store, props.disclosure]);
  useStoreProps(store, props, "open", "setOpen");
  useStoreProps(store, props, "mounted", "setMounted");
  useStoreProps(store, props, "animated");
  return Object.assign(store, {
    disclosure: props.disclosure
  });
}
function useDisclosureStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useStore = useStore(Core.createDisclosureStore, props),
    _useStore2 = _slicedToArray(_useStore, 2),
    store = _useStore2[0],
    update = _useStore2[1];
  return useDisclosureStoreProps(store, update, props);
}
export { useDisclosureStoreProps, useDisclosureStore };